<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item v-if="formData.slot === HOME_ENTRY_SLOT.PROMO" label="副标题" prop="subtitle">
        <el-input v-model="formData.subtitle" clearable placeholder="选填，如：一起更省" />
      </el-form-item>
      <el-form-item label="图标" prop="iconUrl">
        <UploadImg v-model="formData.iconUrl" height="80px" width="80px" />
        <div class="text-12px text-[var(--el-text-color-secondary)] mt-4px">
          选填；不传则 C 端按标题匹配默认橙红图标
        </div>
      </el-form-item>
      <el-form-item label="跳转地址" prop="url">
        <el-input v-model="formData.url" clearable placeholder="选填；不填则仅展示、点击不跳转" />
      </el-form-item>
      <el-form-item v-if="formData.slot === HOME_ENTRY_SLOT.QUICK" label="角标" prop="badgeText">
        <el-input v-model="formData.badgeText" clearable maxlength="8" placeholder="选填，如：热" />
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" controls-position="right" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="memo">
        <el-input v-model="formData.memo" type="textarea" placeholder="选填" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import * as HomeEntryApi from '@/api/mall/market/homeEntry'
import { HOME_ENTRY_SLOT } from '@/api/mall/market/homeEntry'

const { t } = useI18n()
const message = useMessage()

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref({
  id: undefined as number | undefined,
  slot: HOME_ENTRY_SLOT.QUICK as number,
  title: undefined as string | undefined,
  subtitle: undefined as string | undefined,
  iconUrl: undefined as string | undefined,
  url: undefined as string | undefined,
  badgeText: undefined as string | undefined,
  sort: 0,
  status: 0,
  memo: undefined as string | undefined
})
const formRules = reactive({
  title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }],
  sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
})
const formRef = ref()

const open = async (type: string, slot: number, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm(slot)
  if (id) {
    formLoading.value = true
    try {
      formData.value = await HomeEntryApi.getHomeEntry(id)
    } finally {
      formLoading.value = false
    }
  }
}
defineExpose({ open })

const emit = defineEmits(['success'])
const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = { ...formData.value } as HomeEntryApi.HomeEntryVO
    if (formType.value === 'create') {
      await HomeEntryApi.createHomeEntry(data)
      message.success(t('common.createSuccess'))
    } else {
      await HomeEntryApi.updateHomeEntry(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

const resetForm = (slot: number) => {
  formData.value = {
    id: undefined,
    slot,
    title: undefined,
    subtitle: undefined,
    iconUrl: undefined,
    url: undefined,
    badgeText: undefined,
    sort: 0,
    status: 0,
    memo: undefined
  }
  formRef.value?.resetFields()
}
</script>
